export const LOCATION_SELECT_FIELD_TEMPLATE = (data: { name: string, description: string }) => {
    return `
        <div>
            ${ data.description }
        </div>
        <div>
            <span class="label label-xs label-info">
                ${ data.name }
            </span>
        </div>
    `;
};



// WEBPACK FOOTER //
// ./libs/donna-core/src/app/locations/forms/location/location-select-field-template.ts